module.exports = __webpack_public_path__ + "static/media/logo-let-it-trees.14f2e5b0.png";